<template>
  <a-spin :spinning="loading">
    <div class="pull-new">
      <div class="relative">
        <Resource
          :src="mainBg"
          :transform-resource="transformImage"
          class="w-full nationImg"
          style="object-fit: inherit !important"
        />
        <a
          class="link"
          :class="{ 'link-h5': isH5 }"
          href="https://rsjqcmnt5p.feishu.cn/wiki/DpMFwCPLPiFATAkOL2ycgH2Nn0d"
          target="_blank"
          ><LinkOutlined />
          <span class="underline">点击查看活动细则</span>
        </a>
      </div>
    </div>
  </a-spin>
</template>
<script lang="ts" setup>
import { LinkOutlined } from '@ant-design/icons-vue';
const route = useRoute();
const loading = ref(false);

const { isMobile } = useDevice();

const isH5 = computed(() => {
  // query h5 用于管理后台预览
  return isMobile || route.query.h5;
});

const mainBg = computed(() => {
  if (isH5.value) {
    return getFeUrl('/youyan-platform/activities/national-h5.png');
  }
  return getFeUrl('/youyan-platform/activities/pc-race.jpg');
});
</script>
<style lang="scss" scoped>
.pull-new {
  @apply h-screen min-h-[100vh] relative sm:px-[0px] overflow-y-scroll;
  :global(.widget-visible) {
    display: none !important;
  }

  & > img {
    object-fit: inherit !important;
  }
  .link {
    position: absolute;
    left: 31vw;
    bottom: 10.5vw;
    z-index: 99;
    &.link-h5 {
      left: 18vw;
      bottom: 11vw;
      font-size: 12px;
      transform: scale(0.8);
    }
  }
}

.pc-wrapper {
  min-width: 1300px;
}
:global(body) {
  min-width: auto;
  min-height: auto;
}
</style>
